export default () =>
  ({
    default: {
      flex: '1 1 auto',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
  }) as const
